import { customAlphabet } from 'nanoid/non-secure'
import { alphanumeric } from 'nanoid-dictionary'

const nanoid = customAlphabet(alphanumeric, 8)

const generateId = nanoid

export default generateId
